import { createRouter, createWebHistory } from "vue-router";
import { routes } from "vue-router/auto-routes";
import useLoginManager from "@/services/loginManager";

const loginManager = useLoginManager();

declare module "vue-router" {
  interface RouteMeta {
    title?: string;
    checkPrivileges?: () => boolean;
    detailOf?: string;
  }
}

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
    },
    {
      path: "/dashboard",
      name: "dashboard",
      components: {
        default: () => import("@/pages/dashboard.vue"),
        dealer: () => import("@/pages/dashboard@dealer.vue"),
      },
    },
    {
      path: "/logout",
      name: "logout",
      meta: {
        title: "Logout",
      },
      redirect: "/login",
    },
    ...routes,
  ],
});

router.beforeResolve(async to => {
  // check if user can even work in Vortex
  // if logged and has no permission, show error
  await loginManager.init(router);
  if (!loginManager.isLogged.value) {
    // if not on login page
    if (!["/login", "/oidc-callback"].includes(to.name?.toString() || "")) {
      // redirect to login page
      return { name: "/login" };
    }
  }
});

router.beforeResolve(to => {
  // check if user has privileges required for the route
  if (to.meta.checkPrivileges) {
    if (!to.meta.checkPrivileges()) {
      return { name: "/" };
    }
  }
});

export default router;
